module.exports = __webpack_public_path__ + "img/inspiration_04.fcca2e9.jpg";